import '../../scripts/common';
import '../../scripts/animate';
import Component from '../base/Component';

import Breadcrumbs from '../base/Breadcrumbs';
import PageScrollBtn from '../simple/PageScrollBtn';
import CustomersMenu from '../CustomersMenu';

import './styles.css';

/**
 * Блок Клиентам
 */
export default class CustomersPage extends Component {
    static className = 'customers';
}

$(() => {
    Breadcrumbs.create();
    CustomersMenu.create();
    PageScrollBtn.create();
});
